/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Component, Input} from '@angular/core';

@Component({
    selector: 'dash-gis-link-field',
    templateUrl: './link-field.component.html',
    styleUrls: ['./link-field.component.scss']
})
export class LinkFieldComponent {

    @Input() public rowData: any;
    @Input() public fieldDefinition: any;
}
